
export default context => {
    $('.js-sort-container', context).each(function() {
        const $this = $(this)
        const sorted = $this.children('[data-order]')
            .detach()
            .toArray()
            .sort((a, b) => a.getAttribute('data-order') - b.getAttribute('data-order'))
        $this.append(...sorted)
    })
}
